import IndustryModule, { SELECTORS as INDUSTRY_SELECTORS } from '../../../Components/IndustryModule/IndustryModule';

// SCSS
import '../../../Components/IndustryModule/_index.scss';

$(INDUSTRY_SELECTORS.root).each((i, industryModule) => {
    new IndustryModule(industryModule);
});
